import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ChevronRight, Carrot, Utensils, Globe, ShoppingBasket, CookingPot } from "lucide-react";

const ProductList = ({ products = [], onProductClick }) => {
    const { t } = useTranslation();

    const handleFoodbook = async (e, product) => {
        e.preventDefault();
        e.stopPropagation();

        window.open(`https://psinfoodservice.com/product/${product.refid}-/`, '_blank'); //${encodeURIComponent(product.name)}
    } 
    return (
        <div className="space-y-2 overflow-y-auto max-h-[50vh]">
            {Array.isArray(products) && products.map((product) => ( 
                <div
                    key={product.id}
                    className="flex items-center justify-between w-full p-4 hover:pl-6 cursor-pointer border-b-[1px]"
                    onClick={() => onProductClick(product.id)}
                >
                    <span className="font-inter">{product.name}</span>
                    <div className="flex items-center gap-4">
                        {product.brand !== 'Vers' && product.refid !== 0 && (
                            <Globe 
                                className="text-ps-blue-dark" 
                                size={20} 
                                onClick={(e) => handleFoodbook(e, product)}
                                title={t('products.openFoodbook') || 'Open in Foodbook'}
                            />
                        )}
                        {product.type === 'bought' ? (
                            <ShoppingBasket 
                                className="text-ps-blue" 
                                size={20} 
                                title={t('products.bought')}
                            />
                        ) : ( 
                            <CookingPot 
                                className="text-ps-orange" 
                                size={20} 
                                title={t('products.homemade')}
                            />
                        )}
                        <ChevronRight 
                            className="text-ps-blue-dark" 
                            size={20}
                            aria-label={t('common.viewDetails') || 'View details'}
                        />
                    </div>
                </div>
            ))}
        </div>
    );
};

ProductList.propTypes = {
    products: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            name: PropTypes.string.isRequired,
            type: PropTypes.oneOf(['bought', 'homemade']).isRequired,
        })
    ),
    onProductClick: PropTypes.func.isRequired
};

export default ProductList;